export default "<grange-actions></grange-actions>\n<h2>{{ (context | async).title }}</h2>\n<p>{{ (context | async).description }}</p>"